import React from "react";
import CustomText from "./CustomText";
import Colors from "../config/Colors";
import Question1 from "../assets/Question1.svg";
import Question2 from "../assets/Question2.svg";
import Question3 from "../assets/Question3.svg";
import { AnswerFormat } from "./utils";
import {
  IPLTeamLogos,
  mapAbbrToLogo,
  mapAbbrToLogoWithURL,
} from "../types/type";

interface QuestionProps {
  step?: number | undefined;
  type?: string | undefined;
  text1?: string;
  text2?: string;
  choice1?: AnswerFormat;
  choice2?: AnswerFormat;
  logo?: boolean | undefined;
  choice1Image: string;
  choice2Image: string;
  onChoose?: (choice: boolean | undefined) => void;
}

function Question({
  choice1,
  choice1Image,
  choice2,
  choice2Image,
  logo = true,
  step,
  text1,
  text2,
  type,
  onChoose,
}: QuestionProps) {
  const handleChoose = (choice: boolean | undefined) => {
    if (onChoose) {
      onChoose(choice);
    }
  };

  return (
    <div className="containerQuestionContent">
      <div className="otherQuestionTitle">
        <CustomText
          spacing={3}
          weight="400"
          size="smallMedium"
          color={Colors.brownPrimary}
          marginTop={10}
        >
          QUESTION
        </CustomText>
      </div>
      <div className="otherQuestionTracker">
        <div
          className={`otherQuestionTrackerNumberContainer otherQuestionTrackerNumberContainerActive`}
        >
          <div
            className={`otherQuestionTrackerNumber 
             otherQuestionTrackerNumberActive`}
          >
            <CustomText weight="700" size="xsmall" color={Colors.white}>
              1
            </CustomText>
          </div>
        </div>
        <div
          className={`otherQuestionTrackerLine ${
            step && step > 0 && "otherQuestionTrackerLineActive"
          } `}
        ></div>
        <div
          className={`otherQuestionTrackerNumberContainer ${
            step && step >= 1 && "otherQuestionTrackerNumberContainerActive"
          }`}
        >
          <div
            className={`otherQuestionTrackerNumber ${
              step && step >= 1 && "otherQuestionTrackerNumberActive"
            }`}
          >
            <CustomText
              weight="700"
              size="xsmall"
              color={
                step && step >= 1 ? Colors.white : Colors.questionNotActive
              }
            >
              2
            </CustomText>
          </div>
        </div>
        <div
          className={`otherQuestionTrackerLine ${
            step && step > 1 && "otherQuestionTrackerLineActive"
          } `}
        ></div>
        <div
          className={`otherQuestionTrackerNumberContainer ${
            step && step >= 2 && "otherQuestionTrackerNumberContainerActive"
          }`}
        >
          <div
            className={`otherQuestionTrackerNumber ${
              step && step >= 2 && "otherQuestionTrackerNumberActive"
            }`}
          >
            <CustomText
              weight="700"
              size="xsmall"
              color={
                step && step >= 2 ? Colors.white : Colors.questionNotActive
              }
            >
              3
            </CustomText>
          </div>
        </div>
      </div>
      <CustomText
        weight="600"
        size="large"
        color={Colors.primary}
        textAlign="center"
        marginTop={20}
        className="otherQUestionText"
      >
        {text1}{" "}
        <CustomText weight="600" size="large" color={Colors.brownPrimary}>
          {type}
        </CustomText>{" "}
        {text2}
      </CustomText>
      <div
        className="otherQuestionChoiceButton"
        onClick={() => handleChoose(true)}
      >
        <div
          style={{
            width: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        ></div>
        <CustomText weight="600" size="medium" color={Colors.primary}>
          {choice1?.team && choice1.homeTeam
            ? mapAbbrToLogoWithURL(choice1.team, false).name
            : choice1?.buttonText}
        </CustomText>
        <div
          style={{
            width: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {choice1?.team && logo && (
            <img
              src={mapAbbrToLogoWithURL(choice1.team, false).logo}
              alt=""
              className="otherQuestionChoiceLogo"
            />
          )}
        </div>
      </div>
      <div
        className="otherQuestionChoiceButton"
        onClick={() => handleChoose(false)}
      >
        <div
          style={{
            width: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        ></div>
        <CustomText weight="600" size="medium" color={Colors.primary}>
          {choice1?.team && logo
            ? mapAbbrToLogoWithURL(choice1?.team, true).name
            : choice2?.buttonText}
        </CustomText>
        <div
          style={{
            width: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {choice1?.team && logo && (
            <img
              src={mapAbbrToLogoWithURL(choice1?.team, true).logo}
              alt=""
              className="otherQuestionChoiceLogo"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Question;
